import {
    FETCH_VO2MAX_METRICS_START,
    FETCH_VO2MAX_METRICS_SUCCESS,
    FETCH_VO2MAX_METRICS_FAIL,
    FETCH_VO2MAX_RANGES_START,
    FETCH_VO2MAX_RANGES_SUCCESS,
    FETCH_VO2MAX_RANGES_FAIL
} from '../../actions/ActionTypes';

const INITIAL_STATE = {
    vo2MaxMetricsData: null,
    vo2MaxRangesData: null,
    fetching: false,
    success: false,
    error: false
};

const vo2MaxMetricsFetching = (state) => {
    return {
        ...state,
        vo2MaxMetricsData: null,
        key: null,
        fetching: true
    };
};

const vo2MaxMetricsSuccess = (success) => (state, action) => {
    return {
        ...state,
        vo2MaxMetricsData: success ? action.data : null,
        fetching: false,
        success: success,
        error: !success
    };
};

const vo2MaxRangessFetching = (state) => {
    return {
        ...state,
        vo2MaxRangesData: null,
        key: null,
        fetching: true
    };
};

const vo2MaxRangesSuccess = (success) => (state, action) => {
    return {
        ...state,
        vo2MaxRangesData: success ? action.data : null,
        fetching: false,
        success: success,
        error: !success
    };
};

export const isVo2MaxMetricsFetching = (state) => {
    return state.vo2MaxMetrics.fetching;
};

export const isVo2MaxMetricsFetchSuccess = (state) => {
    return state.vo2MaxMetrics.success;
};

export const isVo2MaxMetricsFetchError = (state) => {
    return state.vo2MaxMetrics.error;
};

export const getVo2MaxMetricsData = (state) => {
    return state.vo2MaxMetrics.vo2MaxMetricsData;
};

export const getVo2MaxRangesData = (state) => {
    return state.vo2MaxMetrics.vo2MaxRangesData;
};

export const isVo2MaxRangesFetching = (state) => {
    return state.vo2MaxMetrics.fetching;
};

export const isVo2MaxRangesFetchingError = (state) => {
    return state.vo2MaxMetrics.error;
};

const handlers = {
    [FETCH_VO2MAX_METRICS_SUCCESS]: vo2MaxMetricsSuccess(true),
    [FETCH_VO2MAX_METRICS_START]: vo2MaxMetricsFetching,
    [FETCH_VO2MAX_METRICS_FAIL]: vo2MaxMetricsSuccess(false),
    [FETCH_VO2MAX_RANGES_SUCCESS]: vo2MaxRangesSuccess(true),
    [FETCH_VO2MAX_RANGES_START]: vo2MaxRangessFetching,
    [FETCH_VO2MAX_RANGES_FAIL]: vo2MaxRangesSuccess(false)
};

export default function vo2MaxMetrics(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) {
        return state;
    } else {
        return handler(state, action);
    }
}
